export default __webpack_public_path__ + "static/media/tesla.e5821c51.png";